import { baseAction } from '../../utilityFunctions';
import { NEW_NOTIFICATION } from './actionTypes';

export const newNotification = (data) => baseAction(NEW_NOTIFICATION, data);

